import React, { useState, useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { MdArrowBack as BackIcon } from "react-icons/md";
import { MdArrowForward as ForwardIcon } from "react-icons/md";
import styled from "styled-components";

import { fetchBible } from "../../api/BibleApi";
import Viewer from "../UI/Viewer";
import AppBar, { AppBarContentWrapper } from "../AppBar/AppBar";
import { withPageTracker } from "utils/analytics/hooks";
import Loader from "../UI/Loader";
import ContentWrapper from "../UI/ContentWrapper";
import { Bible } from "../../api/typedefs/Bible";

const BibleName = styled.h1`
  margin-top: 0;
`;

const BibleCopyright = styled.div`
  color: #666;
  font-size: 0.8em;
`;

enum FetchStatus {
  Idle,
  Loading,
  Success,
  Error
}

type BibleInfoParams = {
  bibleId: string;
};

const BibleInfo: React.FC<RouteComponentProps<BibleInfoParams>> = ({
  history,
  match: { params }
}) => {
  const [fetchStatus, setFetchStatus] = useState(FetchStatus.Idle);
  const [bible, setBible] = useState<Bible | null>(null);

  useEffect(() => {
    setFetchStatus(FetchStatus.Loading);
    fetchBible({ bibleId: params.bibleId })
      .then(bible => {
        setBible(bible);
        setFetchStatus(FetchStatus.Success);
      })
      .catch(err => {
        console.log(err);
        setFetchStatus(FetchStatus.Error);
      });
    if (window) window.scrollTo(0, 0);
  }, [params.bibleId]);

  const goBack = () =>
    history.action === "PUSH" ? history.goBack() : history.push("/");

  const scriptDirection =
    (bible && bible.language && bible.language.scriptDirection) || "LTR";

  return (
    <Viewer>
      <AppBar showBackButton>
        <AppBarContentWrapper>
          {fetchStatus === FetchStatus.Success && scriptDirection === "RTL" ? (
            <ForwardIcon size={24} onClick={goBack} />
          ) : (
            <BackIcon size={24} onClick={goBack} />
          )}
        </AppBarContentWrapper>
      </AppBar>
      <ContentWrapper scriptDirection={scriptDirection}>
        {fetchStatus === FetchStatus.Idle && null}
        {fetchStatus === FetchStatus.Loading && <Loader />}
        {fetchStatus === FetchStatus.Error && "Error"}
        {fetchStatus === FetchStatus.Success && bible && (
          <>
            <BibleName
              dangerouslySetInnerHTML={{ __html: bible.nameLocal || "" }}
            />
            <div dangerouslySetInnerHTML={{ __html: bible.info || "" }} />
            <BibleCopyright
              dangerouslySetInnerHTML={{ __html: bible.copyright || "" }}
            />
          </>
        )}
      </ContentWrapper>
    </Viewer>
  );
};

export default withRouter(withPageTracker(BibleInfo));
